if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Initialize accordion functionality for Women menu
      this.initAccordion();

      // Buttons - only for non-accordion menus
      this.menu.querySelectorAll('summary').forEach(summary => {
        const parentDetails = summary.closest('details');
        // Skip accordion items
        if (!parentDetails.classList.contains('accordion-parent') && 
            !parentDetails.classList.contains('accordion-subitem')) {
          summary.addEventListener('click', this.onSummaryClick.bind(this));
        }
      });
      
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

  initAccordion() {
  const OPEN_MS = 320, CLOSE_MS = 260, EASE = 'cubic-bezier(0.4,0,0.2,1)', PADDING = 8;
  const animEl = (el, fromH, toH, done) => {
    if (el._acc) { el._acc.cancel(); el._acc = null; }
    el.style.overflow = 'hidden'; el.style.height = fromH + 'px';
    const a = el.animate([{height:fromH+'px'},{height:toH+'px'}],
      {duration:fromH===0?OPEN_MS:CLOSE_MS, easing:EASE, fill:'forwards'});
    el._acc = a;
    a.onfinish = () => {
      el._acc = null;
      if (toH === 0) { el.style.height='0px'; el.style.overflow='hidden'; el.style.paddingBottom=''; }
      else { el.style.height=''; el.style.overflow=''; }
      if (done) done();
    };
    a.oncancel = () => { el._acc = null; };
  };
  const openDet = (det, sel, pad) => {
    det.setAttribute('open',''); const c = det.querySelector(sel); if (!c) return;
    c.style.paddingBottom = pad + 'px'; animEl(c, 0, c.scrollHeight + pad, null);
  };
  const closeDet = (det, sel) => {
    const c = det.querySelector(sel); if (!c) { det.removeAttribute('open'); return; }
    animEl(c, c.offsetHeight || c.scrollHeight, 0, () => det.removeAttribute('open'));
  };
  this.menu.querySelectorAll('.accordion-parent').forEach(det => {
    const s = det.querySelector(':scope > summary'); if (!s || s._accBound) return; s._accBound = true;
    s.addEventListener('click', e => { e.preventDefault();
      det.hasAttribute('open') ? closeDet(det,':scope > ul.accordion-content')
                               : openDet(det,':scope > ul.accordion-content', PADDING); });
  });
  this.menu.querySelectorAll('.accordion-subitem').forEach(det => {
    const s = det.querySelector(':scope > summary'); if (!s || s._accBound) return; s._accBound = true;
    s.addEventListener('click', e => { e.preventDefault();
      det.hasAttribute('open') ? closeDet(det,':scope > ul.accordion-submenu')
                               : openDet(det,':scope > ul.accordion-submenu', 4); });
  });
}

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }

    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
